import { updateOfficeDivision } from "../../../../../actions/Utilities/OfficeDivision";
import { useMutation } from "react-query";

const useUpdateOfficeDivision = () => {
  return useMutation(updateOfficeDivision);
  // const queryClient = useQueryClient();

  // const { mutate } = useMutation(
  //   (OfficeDivisionNewData) => updateOfficeDivision(OfficeDivisionNewData),
  //   {
  //     onSuccess: () => {
  //       queryClient.invalidateQueries(["GetOfficeDivision"]);
  //       toast.fire("Success", "OfficeDivision Updated Successfully", "success");
  //     },
  //     onError: () => {
  //       toast.fire("Failed", "Failed to Update OfficeDivision", "error");
  //     },
  //   }
  // );
  // return mutate;
};
export default useUpdateOfficeDivision;
